import { render, staticRenderFns } from "./add-service.vue?vue&type=template&id=3baaf408&"
import script from "./add-service.ts?vue&type=script&lang=ts&"
export * from "./add-service.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports